import React, { useMemo } from 'react';
import gql from 'graphql-tag';
import config from '@cardash/config';
import { useQuery } from '@apollo/client';

import { Spinner } from 'reactstrap';
import Error from '../../Error';
import { StyledSelect } from './StyledComponents';
import { GetDistrictsQuery } from '../../graphql';
import useMainContext from '../../../hooks/main-provider';
import { actorRanks } from '../../../../config/common';
import { useSession } from 'next-auth/react';

const GetDistricts = gql`
  ${GetDistrictsQuery}
`;
const DistrictField = () => {
  const { data: session } = useSession();

  const user = session?.user;

  const { updateSelectedDistrict, selectedRegion, selectedDistrict, viewModeDataLoading } = useMainContext();

  const { data, loading, error } = useQuery(GetDistricts, {
    variables: { id: selectedRegion ? selectedRegion.id : null },
    skip: !selectedRegion,
    fetchPolicy: 'network-only',
  });

  const districts = useMemo(() => (data && data.districts) || [], [data]);

  const options = useMemo(
    () =>
      (districts || []).map(r => ({
        label: `${r.name} ${r.displayName ? `- ${r.displayName}` : ''}`,
        value: r.id,
      })),
    [districts]
  );

  const selectedValue = useMemo(() => {
    const district = selectedDistrict && districts.find(r => r.id === Number(selectedDistrict.id));
    if (district) {
      return {
        label: `${district.name} ${district.displayName ? `- ${district.displayName}` : ''}`,
        value: district.id,
      };
    }
    return null;
  }, [selectedDistrict, districts]);

  if (error) return <Error error={error} />;

  if (
    [
      config.actorTypes.LocationManager,
      config.actorTypes.AssistantGeneralManager,
      config.actorTypes.ServiceAdvisor,
      config.actorTypes.Technician,
    ].includes(user.type)
  ) {
    if (loading) {
      return (
        <div>
          <Spinner size="sm" />
        </div>
      );
    }
    if (districts?.length === 1) {
      return <p className="text-light mb-0 me-2 ml-1">{districts[0]?.name || '-'}</p>;
    }
  }

  const isClearable =
    user.rank < actorRanks.districtManager ||
    [actorRanks.regionalCustomerSupport, actorRanks.organizationCustomerSupport].includes(user.rank);

  return (
    <StyledSelect
      classNamePrefix="side-menu-select"
      isClearable={isClearable}
      onChange={selectedItem => {
        const district = selectedItem && districts.find(r => r.id === Number(selectedItem.value));
        updateSelectedDistrict(district && district.id);
      }}
      isLoading={loading || viewModeDataLoading}
      value={selectedValue}
      options={options}
    />
  );
};

const District = () => {
  return (
    <div className="d-flex w-100 mb-2" style={{ maxWidth: 250, margin: '10px 15px' }}>
      <p className="text-light mb-0 me-2">District:</p>
      <DistrictField />
    </div>
  );
};

export default District;
